import List from './HorizontalScrollList';
import ListItem from './HorizontalScrollListItem';

export default { List, ListItem };
